import React from 'react';

function KPICard({ title, value, subtitle, trend, isLoading }) {
  if (isLoading) {
    return (
      <div className="card">
        <div className="card-body flex items-center justify-center min-h-[140px]">
          <div className="flex items-center gap-2 text-secondary-500">
            <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                fill="none"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            <span className="text-sm">Lädt...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card hover:shadow-lg transition-shadow duration-200">
      <div className="card-body">
        <div className="space-y-3">
          {/* Title */}
          <h3 className="text-sm font-medium text-secondary-600 dark:text-secondary-400">
            {title}
          </h3>

          {/* Value */}
          <div className="text-2xl md:text-3xl font-bold text-secondary-900 dark:text-secondary-50">
            {value}
          </div>

          {/* Subtitle and Trend Row */}
          <div className="flex items-center justify-between">
            {subtitle && (
              <span className="text-xs text-secondary-500 dark:text-secondary-400">
                {subtitle}
              </span>
            )}

            {trend !== undefined && trend !== null && (
              <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold ${
                trend >= 0
                  ? 'bg-success-50 text-success-700'
                  : 'bg-error-50 text-error-700'
              }`}>
                <span className="text-sm">
                  {trend >= 0 ? '↑' : '↓'}
                </span>
                <span>
                  {Math.abs(trend).toFixed(1)}%
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default KPICard;
